import { ReactNode } from 'react';
import classNames from 'classnames';
import AppContentMaxWidth from '@lib/layouts/AppLayout/AppContentMaxWidth/AppContentMaxWidth';
import styles from './TabsWrap.module.scss';

interface Props {
  children: ReactNode;
  useAppContentMaxWidth?: boolean;
}

export default function TabsWrap({ children, useAppContentMaxWidth }: Props) {
  if (useAppContentMaxWidth) {
    return (
      <AppContentMaxWidth>
        <div className={styles.tabsWrap}>
          <div className={styles.tabsScroll}>{children}</div>
        </div>
      </AppContentMaxWidth>
    );
  }
  return (
    <div className={classNames(styles.tabsWrap, styles.tabsWrapCentered)}>
      <div>
        <div className={styles.tabsScroll}>{children}</div>
      </div>
    </div>
  );
}
